import ReportingAndAnalysis from '@/views/ReportingAndAnalysis/Index.vue'
import { REPORTS } from '@/constants'
import { buildReportDetailRoute } from '@/views/Reports/ReportExecution/helpers/reportDetailRouting'

export default [
    {
        path: '/reporting-and-analysis',
        name: 'reportingAndAnalysis',
        component: ReportingAndAnalysis,
        redirect: { name: 'reportingAndAnalysisPrepress' },
        meta: {
            title: 'reportingAndAnalysis.root.pageTitle',
            menuRendered: true,
            menuTitle: 'reportingAndAnalysis.root.menuTitle',
            icon: 'mdi-chart-line'
        },
        children: [
            {
                path: '/reporting-and-analysis/prepress',
                name: 'reportingAndAnalysisPrepress',
                component: () => import('@/views/ReportingAndAnalysis/Prepress/Index.vue'),
                redirect: { name: 'reportingAndAnalysisPrepressMenu' },
                meta: {
                    title: 'reportingAndAnalysis.prepress.pageTitle',
                    menuRendered: true,
                    menuTitle: 'reportingAndAnalysis.prepress.menuTitle',
                    requiresAuth: true,
                    permission: 'reports_analysis_read'
                },
                children: [
                    {
                        path: '',
                        name: 'reportingAndAnalysisPrepressMenu',
                        component: () => import('@/views/ReportingAndAnalysis/Prepress/Prepress.vue'),
                        meta: {
                            title: 'reportingAndAnalysis.prepress.pageTitle',
                            requiresAuth: true,
                            permission: 'reports_analysis_read'
                        }
                    },
                    {
                        path: '/reporting-and-analysis/prepress/report-plates',
                        name: 'reportingAndAnalysisPrepressReportPlates',
                        component: () => import('@/views/ReportingAndAnalysis/Prepress/ReportPlates.vue'),
                        meta: {
                            title: 'reportingAndAnalysis.prepress.reportPlates.pageTitle',
                            requiresAuth: true,
                            permission: 'reports_analysis_read'
                        }
                    },
                    {
                        path: '/reporting-and-analysis/prepress/report-additional-plates',
                        name: 'reportingAndAnalysisPrepressReportAdditionalPlates',
                        component: () => import('@/views/ReportingAndAnalysis/Prepress/ReportAdditionalPlates.vue'),
                        meta: {
                            title: 'reportingAndAnalysis.prepress.reportAdditionalPlates.pageTitle',
                            requiresAuth: true,
                            permission: 'reports_analysis_read'
                        }
                    }
                ]
            },
            {
                path: '/reporting-and-analysis/orders',
                name: 'reportingAndAnalysisOrders',
                component: () => import('@/views/ReportingAndAnalysis/Orders/Index.vue'),
                redirect: { name: 'reportingAndAnalysisOrdersMenu' },
                meta: {
                    title: 'reportingAndAnalysis.orders.pageTitle',
                    menuRendered: true,
                    menuTitle: 'reportingAndAnalysis.orders.menuTitle',
                    requiresAuth: true,
                    permission: 'reports_analysis_read'
                },
                children: [
                    {
                        path: '',
                        name: 'reportingAndAnalysisOrdersMenu',
                        component: () => import('@/views/ReportingAndAnalysis/Orders/Orders.vue'),
                        meta: {
                            title: 'reportingAndAnalysis.orders.pageTitle',
                            requiresAuth: true,
                            permission: 'reports_analysis_read'
                        }
                    },
                    {
                        path: '/reporting-and-analysis/orders/sent-orders',
                        name: 'reportingAndAnalysisOrdersSentOrders',
                        component: () => import('@/views/ReportingAndAnalysis/Orders/SentOrders.vue'),
                        meta: {
                            title: 'reportingAndAnalysis.orders.sentOrders.pageTitle',
                            requiresAuth: true,
                            permission: 'reports_analysis_read'
                        }
                    },
                    {
                        path: '/reporting-and-analysis/orders/sent-orders-simple',
                        name: 'reportingAndAnalysisOrdersSentOrdersSimple',
                        component: () => import('@/views/ReportingAndAnalysis/Orders/SentOrdersSimple.vue'),
                        meta: {
                            title: 'reportingAndAnalysis.orders.sentOrdersSimple.pageTitle',
                            requiresAuth: true,
                            permission: 'reports_analysis_read'
                        }
                    },
                    {
                        path: '/reporting-and-analysis/orders/placed-orders',
                        name: 'reportingAndAnalysisOrdersPlacedOrders',
                        component: () => import('@/views/ReportingAndAnalysis/Orders/PlacedOrders.vue'),
                        meta: {
                            title: 'reportingAndAnalysis.orders.placedOrders.pageTitle',
                            requiresAuth: true,
                            permission: 'reports_analysis_read'
                        }
                    },
                    {
                        path: '/reporting-and-analysis/orders/weekly-placed-orders',
                        name: 'reportingAndAnalysisOrdersWeeklySentOrders',
                        component: () => import('@/views/ReportingAndAnalysis/Orders/WeeklySentOrders.vue'),
                        meta: {
                            title: 'reportingAndAnalysis.orders.weeklySentOrders.pageTitle',
                            requiresAuth: true,
                            permission: 'reports_analysis_read'
                        }
                    },
                    {
                        path: '/reporting-and-analysis/orders/monthly-placed-orders',
                        name: 'reportingAndAnalysisOrdersMonthlySentOrders',
                        component: () => import('@/views/ReportingAndAnalysis/Orders/MonthlySentOrders.vue'),
                        meta: {
                            title: 'reportingAndAnalysis.orders.monthlySentOrders.pageTitle',
                            requiresAuth: true,
                            permission: 'reports_analysis_read'
                        }
                    },
                    {
                        path: '/reporting-and-analysis/orders/production-in-progress',
                        name: 'reportingAndAnalysisOrdersOrdersInProgress',
                        component: () => import('@/views/ReportingAndAnalysis/Orders/OrdersInProgress.vue'),
                        meta: {
                            title: 'reportingAndAnalysis.orders.ordersInProgress.pageTitle',
                            requiresAuth: true,
                            permission: 'reports_analysis_read'
                        }
                    }
                ]
            },
            {
                path: '/reporting-and-analysis/reports',
                name: 'reportingAndAnalysisReports',
                component: () => import('@/views/ReportingAndAnalysis/Reports/Index.vue'),
                redirect: { name: 'reportingAndAnalysisReportsReports' },
                meta: {
                    title: 'reportingAndAnalysis.reports.pageTitle',
                    menuRendered: true,
                    menuTitle: 'reportingAndAnalysis.reports.menuTitle',
                    requiresAuth: true,
                    permission: 'reports_review'
                },
                children: [
                    {
                        path: '',
                        name: 'reportingAndAnalysisReportsReports',
                        component: () => import('@/views/ReportingAndAnalysis/Reports/Reports.vue'),
                        meta: {
                            title: 'reportingAndAnalysis.reports.pageTitle',
                            requiresAuth: true,
                            permission: 'reports_review'
                        }
                    },
                    {
                        path: '/reporting-and-analysis/reports/daily-reports-shift-summaries',
                        name: 'reportingAndAnalysisReportsReportsDailyReportsShiftSummaries',
                        component: () => import('@/views/ReportingAndAnalysis/Reports/DailyReportsShiftSummaries/Index.vue'),
                        redirect: {
                            name: 'reportingAndAnalysisReportsReportsDailyReportsShiftSummariesDailyReportsShiftSummaries'
                        },
                        meta: {
                            title: 'reportingAndAnalysis.reports.dailyShiftSummaries.pageTitle',
                            requiresAuth: true,
                            permission: 'reports_review'
                        },
                        children: [
                            {
                                path: '',
                                name: 'reportingAndAnalysisReportsReportsDailyReportsShiftSummariesDailyReportsShiftSummaries',
                                component: () =>
                                    import('@/views/ReportingAndAnalysis/Reports/DailyReportsShiftSummaries/DailyReportsShiftSummaries.vue'),
                                meta: {
                                    title: 'reportingAndAnalysis.reports.dailyShiftSummaries.pageTitle',
                                    requiresAuth: true,
                                    permission: 'reports_review'
                                }
                            },
                            {
                                path: '/reporting-and-analysis/reports/daily-reports-shift-summaries/:id',
                                name: 'reportingAndAnalysisReportsReportsDailyReportsShiftSummariesDetailedReports',
                                component: () =>
                                    import('@/views/ReportingAndAnalysis/Reports/DailyReportsShiftSummaries/DetailedReports.vue'),
                                meta: {
                                    title: 'reportingAndAnalysis.reports.dailyShiftSummaries.detailed.pageTitle',
                                    requiresAuth: true,
                                    permission: 'reports_review'
                                }
                            },
                            {
                                path: '/reporting-and-analysis/reports/daily-reports-shift-summaries/:reportShiftSummaryId/reports/:id',
                                name: 'reportingAndAnalysisReportsReportsDailyReportsShiftSummariesDetailedReportsReport',
                                redirect: (to) =>
                                    buildReportDetailRoute({
                                        reportId: to.params.id,
                                        origin: REPORTS.DETAIL_ORIGINS.REPORTING_AND_ANALYSIS,
                                        originSummaryId: to.params.reportShiftSummaryId
                                    }),
                                meta: {
                                    title: 'reportingAndAnalysis.reports.dailyShiftSummaries.detailed.report.pageTitle',
                                    requiresAuth: true,
                                    permission: 'reports_review'
                                }
                            },
                            {
                                path: '/reporting-and-analysis/reports/daily-shipments-reports-shift-summaries/:id',
                                name: 'reportingAndAnalysisReportsReportsDailyShipmentsReportsShiftSummariesDetailedShipmentsReports',
                                component: () =>
                                    import('@/views/ReportingAndAnalysis/Reports/DailyReportsShiftSummaries/DetailedShipmentsReports.vue'),
                                meta: {
                                    title: 'reportingAndAnalysis.reports.dailyShiftSummaries.detailedShipments.pageTitle',
                                    requiresAuth: true,
                                    permission: 'reports_review'
                                }
                            },
                            {
                                path: '/reporting-and-analysis/reports/daily-shipments-reports-shift-summaries/:reportShiftSummaryId/:id',
                                name: 'reportingAndAnalysisReportsReportsDailyShipmentsReportsShiftSummariesDetailedReportsShipmentReport',
                                redirect: (to) => ({
                                    name: 'reportingAndAnalysisReportsReportsDailyShipmentsReportsShiftSummariesDetailedShipmentsReports',
                                    params: { id: to.params.reportShiftSummaryId }
                                }),
                                meta: {
                                    title: 'reportingAndAnalysis.reports.dailyShiftSummaries.detailedShipments.report.pageTitle',
                                    requiresAuth: true,
                                    permission: 'reports_review'
                                }
                            }
                        ]
                    },
                    {
                        path: '/reporting-and-analysis/reports/users-ranking',
                        name: 'reportingAndAnalysisReportsUsersRanking',
                        component: () => import('@/views/ReportingAndAnalysis/Reports/UsersRanking/Index.vue'),
                        meta: {
                            title: 'reportingAndAnalysis.reports.usersRanking.pageTitle',
                            requiresAuth: true,
                            permission: 'user_ranking_admin_read'
                        }
                    },
                    {
                        path: '/reporting-and-analysis/reports/summaries',
                        name: 'reportingAndAnalysisReportsReportsSummaries',
                        component: () => import('@/views/ReportingAndAnalysis/Reports/ReportsSummaries/Index.vue'),
                        meta: {
                            title: 'reportingAndAnalysis.reports.reportsSummaries.pageTitle',
                            requiresAuth: true,
                            permission: 'reports_review'
                        }
                    }
                ]
            },
            {
                path: '/reporting-and-analysis/jobs',
                name: 'reportingAndAnalysisJobs',
                component: () => import('@/views/ReportingAndAnalysis/Jobs/Index.vue'),
                redirect: { name: 'reportingAndAnalysisJobsJobs' },
                meta: {
                    title: 'reportingAndAnalysis.jobs.pageTitle',
                    menuRendered: true,
                    menuTitle: 'reportingAndAnalysis.jobs.menuTitle',
                    requiresAuth: true,
                    permission: 'reports_analysis_read'
                },
                children: [
                    {
                        path: '',
                        name: 'reportingAndAnalysisJobsJobs',
                        component: () => import('@/views/ReportingAndAnalysis/Jobs/Jobs.vue'),
                        meta: {
                            title: 'reportingAndAnalysis.jobs.pageTitle',
                            requiresAuth: true,
                            permission: 'reports_analysis_read'
                        }
                    },
                    {
                        path: '/reporting-and-analysis/jobs/ncf-jobs',
                        name: 'reportingAndAnalysisJobsNCFJobs',
                        component: () => import('@/views/ReportingAndAnalysis/Jobs/NCFJobs.vue'),
                        meta: {
                            title: 'reportingAndAnalysis.jobs.ncfJobs.pageTitle',
                            requiresAuth: true,
                            permission: 'reports_analysis_read'
                        }
                    }
                ]
            },
            {
                path: '/reporting-and-analysis/fv-from-xl',
                name: 'reportingAndAnalysisFVFromXL',
                component: () => import('@/views/ReportingAndAnalysis/FVFromXL/Index.vue'),
                meta: {
                    title: 'reportingAndAnalysis.fvFromXL.pageTitle',
                    menuRendered: true,
                    menuTitle: 'reportingAndAnalysis.fvFromXL.menuTitle',
                    requiresAuth: true,
                    permission: ['reports_analysis_read']
                }
            },
            {
                path: '/reporting-and-analysis/cooperation-paper',
                name: 'reportingAndAnalysisCooperationPaper',
                component: () => import('@/views/ReportingAndAnalysis/CooperationPaper/Index.vue'),
                meta: {
                    title: 'reportingAndAnalysis.cooperationPaper.pageTitle',
                    menuRendered: true,
                    menuTitle: 'reportingAndAnalysis.cooperationPaper.menuTitle',
                    requiresAuth: true,
                    permission: 'reports_analysis_read'
                }
            }
        ]
    }
]
